import { defineAsyncComponent } from 'vue'

import BBadge from './BBadge.vue'
import BContainer from './BContainer.vue'
import BCol from './BCol.vue'
import BRow from './BRow.vue'
import BSkeleton from './BSkeleton.vue'
import BSkeletonTable from './BSkeletonTable.vue'
import BSkeletonWrapper from './BSkeletonWrapper.vue'
import BDropdownDivider from './BDropdownDivider.vue'
import BDropdownHeader from './BDropdownHeader.vue'
import BDropdownGroup from './BDropdownGroup.vue'
import BDropdownForm from './BDropdownForm.vue'
import BDropdownText from './BDropdownText.vue'
import BDropdownItem from './BDropdownItem.vue'
import BDropdownItemButton from './BDropdownItemButton.vue'
import BNav from './BNav.vue'
import BNavItem from './BNavItem.vue'
import BButton from './BButton.vue'
import BButtonGroup from './BButtonGroup.vue'
import BProgress from './BProgress.vue'
import BInputGroupText from './BInputGroupText.vue'
import BInputGroupAppend from './BInputGroupAppend.vue'
import BInputGroup from './BInputGroup.vue'
import BDropdown from './BDropdown.vue'
import BForm from './BForm.vue'
import BCollapse from './BCollapse.vue'
import BFormCheckbox from './BFormCheckbox.vue'
import BFormInvalidFeedback from './BFormInvalidFeedback.vue'
import BFormGroup from './BFormGroup.vue'
import BFormInput from './BFormInput.vue'
import BFormSelect from './BFormSelect.vue'
import BFormRadio from './BFormRadio.vue'
import BFormRadioGroup from './BFormRadioGroup.vue'
import BPagination from './BPagination.vue'
import BModal from './BModal.vue'
import BTooltip from './BTooltip.vue'
import BTabs from './BTabs.vue'
import BTab from './BTab.vue'
import DataTable from './table/DataTable.vue'
import BPopover from './BPopover.vue'
import VBToggle from './VBToggle'
import VBTooltip from './VBTooltip'
import VBPopover from './VBPopover'
import { useListenOnRoot } from './useListenOnRoot'
import Prism from './VuePrism'

import {
  elActionBtn,
  elBootstrapDropdown,
  elCallout,
  elCaretBtn,
  elConfirmModal,
  elDnaLoader,
  elDotLoader,
  elEntityBox,
  elInlineEditBox,
  elIcon,
  elLiveBtn,
  elPasswordInput,
  elRange,
  elRemovableListItem,
  elSegmentedControl,
  elTable,
  elTimeRangeControls,
  elToken,
  elWizard,
  HiddenKeyValue,
  HorizontalSplitContainer,
  ToggleButton,
  PlaceholderBlock,
  PlaceholderElement,
  ListFilterBar,
  TextEllipsis,
  CircleProgressBar,
  elCarousel
} from './elements'

const DropZone = defineAsyncComponent(() => import('./DropZone.vue'))
const MonacoEditor = defineAsyncComponent(() => import('./vue-monaco'))

export {
  BBadge,
  BButton,
  BButtonGroup,
  BCol,
  BCollapse,
  BContainer,
  BDropdown,
  BDropdownDivider,
  BDropdownHeader,
  BDropdownItem,
  BDropdownItemButton,
  BDropdownText,
  BDropdownForm,
  BDropdownGroup,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupText,
  BModal,
  BNav,
  BNavItem,
  BPagination,
  BPopover,
  BProgress,
  BRow,
  BSkeleton,
  BSkeletonTable,
  BSkeletonWrapper,
  BTab,
  BTabs,
  BTooltip,
  VBPopover,
  VBToggle,
  VBTooltip,
  useListenOnRoot,
  DataTable,
  DropZone,
  elActionBtn,
  elBootstrapDropdown,
  elCallout,
  elCaretBtn,
  elConfirmModal,
  elDnaLoader,
  elDotLoader,
  elEntityBox,
  elInlineEditBox,
  elIcon,
  elLiveBtn,
  elPasswordInput,
  elRange,
  elRemovableListItem,
  elSegmentedControl,
  elTable,
  elTimeRangeControls,
  elToken,
  elWizard,
  HiddenKeyValue,
  HorizontalSplitContainer,
  ToggleButton,
  PlaceholderBlock,
  PlaceholderElement,
  ListFilterBar,
  MonacoEditor,
  TextEllipsis,
  CircleProgressBar,
  Prism,
  elCarousel
}
